import { render, staticRenderFns } from "./PageSet.vue?vue&type=template&id=2a53bcc6&scoped=true&"
import script from "./PageSet.vue?vue&type=script&lang=js&"
export * from "./PageSet.vue?vue&type=script&lang=js&"
import style0 from "./PageSet.vue?vue&type=style&index=0&id=2a53bcc6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a53bcc6",
  null
  
)

export default component.exports